import {createRouter, createWebHistory} from "vue-router";

import store from "@/store";

import MainMenu from "@/components/MainMenu";
import PagePVP from "@/components/PagePVP";
import PageProfile from "@/components/PageProfile";


const routes = [
  { path: '/', component: MainMenu },
  { path: '/pvp', component: PagePVP },
  { path: '/profile', component: PageProfile },
  // Настройки: язык интерфейса (и место под будущие параметры — звук и т.п.)
  { path: '/options', component: () => import('@/components/PageOptions') },
]

// Новый веб-клиент (PixiJS) — за фича-флагом. Лобби и Unity не затрагиваются.
// Включить локально: VUE_APP_ENABLE_WEB_CLIENT=true (см. .env.template), затем открыть /play-web.
if (process.env.VUE_APP_ENABLE_WEB_CLIENT === 'true') {
  routes.push({
    path: '/play-web',
    component: () => import('@/components/PagePlayWeb'),
  })
  // Окно амуниции (Pack) — управление инвентарём/экипировкой/разбором вне партии.
  routes.push({
    path: '/pack',
    component: () => import('@/components/PagePack'),
  })
  // Вход в мир для новичка: выбор стороны + дар наставника (BackEnd/docs/TUTORIAL_PLAN.md, Акт 0).
  routes.push({
    path: '/start',
    component: () => import('@/components/PageStart'),
  })
  // «Справка» — куда превращается пункт «Обучение» после его прохождения (темы + перепройти акт).
  routes.push({
    path: '/help',
    component: () => import('@/components/PageHelp'),
  })
  // Задания дня — ежедневные задания, сундуки, серия (docs/daily/, BackEnd/docs/DAILY_PLAN.md).
  routes.push({
    path: '/daily',
    component: () => import('@/components/PageDaily'),
  })
  // Колесо фортуны — потратить билет (рефералка/магазин) на случайный приз.
  routes.push({
    path: '/wheel',
    component: () => import('@/components/PageWheel'),
  })
  // Рынок — P2P-биржа: продажа/покупка амуниции, материалов и самоцветов за энергию.
  routes.push({
    path: '/market',
    component: () => import('@/components/PageMarket'),
  })
  // Аренда NFT-фигур: витрина предложений, «я сдал» (заработок и цена досрочного возврата) и
  // «я взял» (BackEnd/apps/web3/rent.py, спецификация оунера 2026-09-10). Отдельный экран, а не
  // вкладка Рынка: у сделки три разных взгляда, и в один список они не складываются.
  routes.push({
    path: '/rent',
    component: () => import('@/components/PageRent'),
  })
  // Магазин за Telegram Stars — наборы расходников (BackEnd/docs/STARS_SHOP_PLAN.md).
  // 🔴 Покупка возможна ТОЛЬКО в мини-аппе (`openInvoice` — метод Telegram.WebApp); в браузере экран
  // показывает каталог и ссылку в мини-апп. Сам раздел выключен, пока в админке нет
  // `stars_shop.enabled` — тогда `/stars/shop` отвечает 404, и экран это объясняет.
  routes.push({
    path: '/stars',
    component: () => import('@/components/PageStars'),
  })
  // Турниры (Сезоны) — список + карточка турнира + таблица + зал славы (регистрация/вход в суб-аккаунт).
  routes.push({
    path: '/tournaments',
    component: () => import('@/components/PageSeasons'),
  })
  // Рабочий стол турнира — что видит игрок ВНУТРИ сезонной сессии (бой/фигуры/таблица/награды/правила).
  routes.push({
    path: '/tournament',
    component: () => import('@/components/PageSeasonDesk'),
  })
  // Магазин случайной амуниции за энергию — ВРЕМЕННО ОТКЛЮЧЁН (2026-07-14, решение оунера): ТОП-шмот за
  // энергию + кратный приток энергии с ростом силы фракций = имбаланс. PageShop.vue оставлен под будущую
  // внутриигровую торговлю шмотом/ресурсами + аренду NFT-воинов.
  // routes.push({
  //   path: '/shop',
  //   component: () => import('@/components/PageShop'),
  // })
}

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// 🔴 ОБУЧЕНИЕ ЗНАЕТ, ГДЕ ИГРОК (модель «что пройдено», 2026-08-20): сервер шлёт список доступных
// шагов ПО КАЖДОМУ ЭКРАНУ, и стор выбирает из него по текущему роуту. Без этой строки геттер
// `tutorialStep` не знал бы, чей список брать, и подсказки молчали бы на всех экранах.
// `beforeEach`, а не `afterEach`: экран монтируется раньше, чем отработает afterEach, и первый
// расчёт подсказки шёл бы по ПРЕДЫДУЩЕМУ роуту.
router.beforeEach((to, from, next) => {
  try { store.commit('SET_TUT_ROUTE', to.path); } catch (e) { /* стор может быть ещё не готов */ }
  next();
})

export default router
